import Delegate from 'ftdomdelegate'

import Accessibility from '../tools/accessibility'

export default class Drawer {
  constructor(element) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.onOpen = options['onOpen'] || function () {};
    this.onClose = options['onClose'] || function () {};

    this.isOpen = false;
    this.direction = this.element.classList.contains('drawer--fromLeft') ? 'fromLeft' : 'fromRight';

    this.pageOverlayElement = document.querySelector('.pageOverlay');

    this._attachListeners();
  }

  destroy() {
    this.delegateBody.off('click', '[data-action="open-drawer"][data-drawer-id="' + this.element.id + '"]');
    this.delegateBody.off('click', '[data-action="close-drawer"][data-drawer-id="' + this.element.id + '"]');
    window.removeEventListener('resize', this._calculateMaxHeightListener);
  }
  toggle() {
    this.isOpen ? this.close() : this.open();
  }
  open(event) {
    if (this.isOpen) {
      return;
    }

    if (event) {
      event.preventDefault();
    }

    this.element.setAttribute('aria-hidden', 'false');
    this._calculateMaxHeight();

    document.documentElement.classList.add('no-scroll');

    // This prevent the body to scroll on iOS. This is honestly a bit hacky, but until the platform supports "touch-action: none" like
    // other browsers, this is the only way to achieve that
    // disableBodyScroll(true, '[data-scrollable]');
    Accessibility.trapFocus(this.element, 'drawer');

    // We attach an event to the page overlay to close it
    this.pageOverlayElement.classList.add('is-visible');
    this.pageOverlayElement.addEventListener('click', this._closeListener);

    this.isOpen = true;

    this.onOpen(); // Call the callback to allow other code to hook their logic

    return false;
  }
  close(event) {
    if (!this.isOpen) {
      return;
    }

    if (event) {
      event.preventDefault();
    }

    this.element.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove('no-scroll');

    // disableBodyScroll(false, '[data-scrollable]');
    Accessibility.removeTrapFocus(this.element, 'drawer');

    this.pageOverlayElement.classList.remove('is-visible');
    this.pageOverlayElement.removeEventListener('click', this._closeListener);

    this.isOpen = false;

    this.onClose(); // Call the callback to allow other code to hook their logic
  }
  _attachListeners() {
    this._openListener = this.open.bind(this);
    this._closeListener = this.close.bind(this);
    this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this);

    this.delegateBody.on('click', '[data-action="open-drawer"][data-drawer-id="' + this.element.id + '"]', this._openListener);
    this.delegateBody.on('click', '[data-action="close-drawer"][data-drawer-id="' + this.element.id + '"]', this._closeListener);
    this.element.addEventListener('keyup', this._handleKeyboard.bind(this));
    window.addEventListener('resize', this._calculateMaxHeightListener);
  }

  /**
   * Make sure that we force a max-height so that the drawer always stays on screen
   */

  _calculateMaxHeight() {
    this.element.style.maxHeight = window.innerHeight + 'px';
  }

  /**
   * Handle a11y events
   */
  _handleKeyboard(event) {
    if (this.isOpen && event.keyCode === 27) {
      this.close();
    }
  }
}